import { WorkspaceRole } from 'models/user'
import { useUserData } from 'components/contexts/UserDataContext'

export function useCanBulkActOnProperties(): boolean {
  const { currentUserWorkspace } = useUserData()

  return currentUserWorkspace?.role === WorkspaceRole.ADMIN
}
